/**
 * @flow
 * @relayHash c119d7d884cb0934019041d54e4ae5e0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExternalProviderMutationInput = {|
  id?: ?string,
  name: string,
  description: string,
  workTime?: ?string,
  address?: ?string,
  contacts: $ReadOnlyArray<?ContactInputObjectType>,
  imageId?: ?number,
  pmcLogo: string,
  pmcPhone: string,
  sendInvite: boolean,
  clientMutationId?: ?string,
|};
export type ContactInputObjectType = {|
  type: string,
  value?: ?string,
|};
export type CreateProviderPageMutationVariables = {|
  input: ExternalProviderMutationInput
|};
export type CreateProviderPageMutationResponse = {|
  +mutateProviderEx: ?{|
    +provider: ?{|
      +id: string
    |}
  |}
|};
export type CreateProviderPageMutation = {|
  variables: CreateProviderPageMutationVariables,
  response: CreateProviderPageMutationResponse,
|};
*/


/*
mutation CreateProviderPageMutation(
  $input: ExternalProviderMutationInput!
) {
  mutateProviderEx(input: $input) {
    provider {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ExternalProviderMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mutateProviderEx",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ExternalProviderMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "provider",
        "storageKey": null,
        "args": null,
        "concreteType": "ProviderNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateProviderPageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateProviderPageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateProviderPageMutation",
    "id": null,
    "text": "mutation CreateProviderPageMutation(\n  $input: ExternalProviderMutationInput!\n) {\n  mutateProviderEx(input: $input) {\n    provider {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5248e610acf3f74e59b570a93145c42f';
module.exports = node;
